<!-- Pestaña Facturación — siempre editable (patrón de las demás tabs). El hero + resumen + datos
     + conceptos viven en <app-billing-form>. Este wrapper solo carga el billing y muestra toasts. -->
<div class="billing-tab">
  <p-toast></p-toast>

  <div class="billing-loading" *ngIf="isLoading">
    <div class="loading-content">
      <p-progressSpinner strokeWidth="4" fill="transparent" animationDuration="0.5s"></p-progressSpinner>
      <p>Cargando información de facturación...</p>
    </div>
  </div>

  <app-billing-form
    *ngIf="!isLoading"
    [leaseId]="leaseDetailService.id"
    [initialData]="billingInfo || undefined"
    [mode]="mode"
    [suggestedRent]="suggestedRent"
    [fiscalSummary]="fiscalSummary"
    (onSubmit)="handleFormSubmit($event)"
    (onCancel)="handleCancel()">
  </app-billing-form>
</div>
